import * as React from 'react'

import { Box, Section, Spinner, Title } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'

import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

import Form from './form'
import { useToleranceSettings } from './hooks/useToleranceSettings'

type TitleProps = React.ComponentProps<typeof Title>

interface Props {
  attendanceSetting: AttendanceSetting
}

const ToleranceSettings = ({ attendanceSetting }: Props) => {
  const { toleranceSettings, loading } = useToleranceSettings(attendanceSetting.attributes.id)

  const descriptionLink: TitleProps['link'] = {
    href: helpCenterUrl('time_tracking_tolerance'),
    label: i18n.t('time_tracking.settings.tolerance_settings.common.description_link'),
  }

  return (
    <Box aria-label="attendance-tolerance-setting">
      <Section
        illustration="calendar-clock"
        title={i18n.t('time_tracking.settings.tolerance_settings.common.title')}
        description={i18n.t('time_tracking.settings.tolerance_settings.common.description')}
        link={descriptionLink}
      >
        {loading ? (
          <Spinner />
        ) : (
          <Form attendanceSetting={attendanceSetting} toleranceSetting={toleranceSettings[0]} />
        )}
      </Section>
    </Box>
  )
}

export default observer(ToleranceSettings)
